<template>
<v-container>
  <v-card>
    <v-card-title>
      <strong>Icone</strong>
      <v-btn fab dark small color="#4EABDD" @click="insertNewRecord()">
        <v-icon dark>add</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search">
      <template slot="items" slot-scope="props">
        <tr @click="updateRecord(props.item.id)">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.codice }}</td>
          <td class="text-xs-left">{{ props.item.descrizione }}</td>
          <td class="text-xs-left">
            <v-icon v-html="props.item.icona"></v-icon>
          </td>
        </tr>
      </template>
      <template
        slot="pageText"
        slot-scope="{ pageStart, pageStop }"
      >From {{ pageStart }} to {{ pageStop }}</template>
    </v-data-table>
  </v-card>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      pagination: {},
      headers: [
        { text: "Id", align: "left", value: "id" },
        { text: "Codice", align: "left", value: "codice" },
        { text: "Descrizione", align: "left", value: "descrizione" },
        { text: "Icona", align: "left", value: "icona" }
      ],
      items: []
    };
  },
  created(){
    this.$store.dispatch("ImpostaScollegamento");
  },
  mounted() {
    this.CheckJWT();
    this.getIcons();
  },
  methods: {
    getIcons() {
      axios.get(this.$store.state.servicePath + "/api/ArStatiSpediziones").then(res => {
        this.items = res.data;
      });
    },
    insertNewRecord() {
      this.$router.push({ path: `/icone/0` });
    },
    updateRecord(recid) {
      this.$router.push({ path: `/icone/${recid}` });
    },
   CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    }
  }
};
</script>